"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withResolutionError = exports.errorRepresentation = void 0;
const errorRepresentation = (metadata) => {
    return {
        didResolutionMetadata: metadata,
        didDocument: null,
        didDocumentMetadata: {},
    };
};
exports.errorRepresentation = errorRepresentation;
const withResolutionError = (f) => {
    return f().catch((e) => exports.errorRepresentation({
        error: 'invalidDid',
        message: e.toString(),
    }));
};
exports.withResolutionError = withResolutionError;
